(function ViatorView($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Viator/view/', function onload() {
			var map;// eslint-disable-line no-unused-vars
			var lat;
			var lon;

			// Adzuki.ToggleableSection('[data-toggle="collapse"][data-cookie]');
			$('.adzicon-expand').click(function expand(e) {
				$(this).toggleClass('fa-minus-square');
				$(this).toggleClass('fa-plus-square');
			});

			$('.consumer-url-copy').click(function doUrlCopy(e) {
				var copyText   = $(this).data('consumer-url');
				const textArea = document.createElement("textarea");

				e.preventDefault();

				textArea.value = copyText;
				document.body.appendChild(textArea);
				textArea.focus();
				textArea.select();

				try {
					document.execCommand('copy');
				} catch (err) {
					console.error('Unable to copy to clipboard', err);
				}

				document.body.removeChild(textArea);
			});

			if ($('#map').length) {
				lat = parseFloat($('#map').data('lat'));
				lon = parseFloat($('#map').data('lon'));

				map = new Adzuki.Map('#google_map', {
					lat: lat,
					lng: lon
				});
			}
		});
	});

	// custom functions
}(jQuery, window.Adzuki || {}));
